import Box from '@mui/material/Box';
import { useTheme, styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const StErrorPageContainer = styled(Box)(() => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(500));
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.neutral2.main,
    marginBottom: '0',
    padding: '20px',
    '.content': {
      maxWidth: '556px',
      padding: '0px 24px',
    },
    '.title': {
      color: theme.palette.themeColor.main,
      fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
      fontSize: isMobile ? '26px' : '32px',
      fontWeight: 600,
      lineHeight: '35px',
      letterSpacing: '0em',
      textAlign: 'center',
    },
    '.sub-content': {
      textAlign: 'center',
      fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
    },
    '.back-btn': {
      textAlign: 'center',
      fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
    },
    '.back-link': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      padding: '8px 22px',
      lineHeight: '2rem',
    },
  };
});

export default StErrorPageContainer;
